const CODE_BLOCK_TABLE_REGEX = /```[\s\S]*?\|[\s\S]*?\|[\s\S]*?```/g;
const INLINE_CODE_TABLE_REGEX = /`[\s\S]*?\|[\s\S]*?\|[\s\S]*?`/g;

export const deduplicateMessages = (messages) => {
  const seen = new Set();
  return messages.filter((message) => {
    const key = `${message.sender}-${message.text}`;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

export const processMessageText = (text) => {
  let processedText = text;

  processedText = processedText.replace(CODE_BLOCK_TABLE_REGEX, (match) =>
    match.replace(/```/g, '').trim()
  );

  processedText = processedText.replace(INLINE_CODE_TABLE_REGEX, (match) =>
    match.replace(/`/g, '').trim()
  );

  return processedText;
};

export const formatMessageTime = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return '';
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${hours}:${minutes}`;
};
